/* BGC 2026: homepage Felipe + Our Story farmer-link repair. Announcement text is owned by theme/header authority. */
(function(){
  'use strict';

  var FARMER_URL='/pages/copia-our-story#get-to-know-our-farmers';
  var FARMER_HASH='#get-to-know-our-farmers';
  var FELIPE_URL='https://youtu.be/olnH2V-4J7Q';
  var observer=null;

  function norm(value){
    return (value||'').replace(/\s+/g,' ').trim().toUpperCase();
  }

  function ensureStyles(){
    if(document.getElementById('bgc-farmer-anchor-repair')) return;
    var style=document.createElement('style');
    style.id='bgc-farmer-anchor-repair';
    style.textContent='#get-to-know-our-farmers{scroll-margin-top:clamp(96px,12vw,150px)!important}';
    document.head.appendChild(style);
  }

  function repairHomeCards(){
    document.querySelectorAll('.bgc-video-strip .bgc-video-card').forEach(function(card){
      var labelNode=card.querySelector('.bgc-video-card__label');
      var label=norm(labelNode&&labelNode.textContent);

      if(label==='MEET OUR BRAZILIAN FARMERS'){
        card.setAttribute('href',FARMER_URL);
        card.removeAttribute('target');
        card.removeAttribute('rel');
        card.dataset.bgcFarmerDestination='canonical';
      }

      if(label==='INVERTED AEROPRESS'){
        card.setAttribute('href',FELIPE_URL);
        card.setAttribute('target','_blank');
        card.setAttribute('rel','noopener');
        card.dataset.bgcFelipeVideo='olnH2V-4J7Q';
      }
    });
  }

  function replaceWithNativeJump(anchor){
    if(!anchor||!anchor.parentNode) return anchor;
    if(anchor.dataset.bgcCanonicalJump==='1'){
      anchor.setAttribute('href',FARMER_HASH);
      return anchor;
    }
    var clone=anchor.cloneNode(true);
    clone.setAttribute('href',FARMER_HASH);
    clone.removeAttribute('onclick');
    clone.dataset.bgcCanonicalJump='1';
    anchor.parentNode.replaceChild(clone,anchor);
    return clone;
  }

  function repairStoryLinks(){
    if(location.pathname!='/pages/copia-our-story') return;

    document.querySelectorAll('.bgc-story-videos').forEach(function(section){
      if(section.id==='bgc-farmer-videos'||section.id==='get-to-know-our-farmers'){
        section.id='bgc-farmer-videos-legacy';
      }
    });

    var section=document.querySelector('.bgc-farmer-videos-fixed');
    if(!section) return;
    section.id='get-to-know-our-farmers';

    var oldMarker=document.getElementById('farm-videos');
    if(oldMarker) oldMarker.remove();

    document.querySelectorAll('a').forEach(function(anchor){
      var text=norm(anchor.textContent);
      if(anchor.classList.contains('bgc-story-jump')||text.indexOf('FARM VIDEOS BELOW')!==-1){
        replaceWithNativeJump(anchor);
      }
    });

    if(location.hash===FARMER_HASH&&!section.dataset.bgcHashPositioned){
      section.dataset.bgcHashPositioned='1';
      setTimeout(function(){ section.scrollIntoView({block:'start'}); },0);
    }
  }

  function repair(){
    ensureStyles();
    repairHomeCards();
    repairStoryLinks();
  }

  function startShortObserver(){
    if(observer||!document.body||typeof MutationObserver==='undefined') return;
    observer=new MutationObserver(function(){ repair(); });
    observer.observe(document.body,{childList:true,subtree:true});
    setTimeout(function(){
      if(observer){ observer.disconnect(); observer=null; }
    },5000);
  }

  function init(){
    repair();
    startShortObserver();
    setTimeout(repair,150);
    setTimeout(repair,800);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }

  document.addEventListener('shopify:section:load',function(){ setTimeout(repair,0); });
})();